import { Path, UseFormRegister } from "react-hook-form";
import clsx from "clsx";
import styles from "./style.module.scss";

interface IProps {
  id?: string;
  name?: Path<any>;
  checked?: boolean;
  register?: UseFormRegister<any>;
  onChange?: (event: any) => void;
  prefix?: string | React.ReactNode;
  suffix?: string | React.ReactNode;
  className?: string;
  labelClass?: string;
  bgColor?: string;
  disabled?: boolean;
}

export default function Toggle({
  id = "smart-toggle",
  name,
  checked,
  register,
  onChange,
  prefix,
  suffix,
  className,
  labelClass,
  bgColor,
  disabled = false
}: Readonly<IProps>) {
  return (
    <label className={clsx(styles.toggleWrapper, className, { "cursor-not-allowed": disabled })}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        className="peer"
        hidden
        disabled={disabled}
        onChange={onChange}
        {...(register && name && register(name))}
      />
      {prefix ? <span>{prefix}</span> : null}
      <span
        className={clsx(
          "peer-focus:outline-none peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-none peer-checked:before:translate-x-0",
          styles.toggleBody,
          labelClass,
          bgColor ?? "before:bg-primary"
        )}
      />
      {suffix ? <span>{suffix}</span> : null}
    </label>
  );
}
